<template>
  <WebTop />
  <div id="body-wrap">

  <div class="home-block-title" style="margin-top: 24px;">
    <Icon type="ios-book-outline" color="#2d8cf0" /> <b style="color: #2d8cf0">投诉举报</b>
  </div>

  <Alert v-if="applies==null"><br />您暂时没有投诉举报<br /><br /></Alert>
  <List v-else item-layout="vertical"  style="padding: 12px; border: solid 1px #dcdee2; border-top: none;">
    
    <ListItem v-for="item in applies" :key="item.id">
      <ListItemMeta>
        <template #title><RouterLink :to="{path: '/complaint/apply/detail', query: {id: item.id}}"><b>{{ item.title }}</b></RouterLink></template>
        <!-- <template #description>{{ item.forumDesc }}</template> -->
      </ListItemMeta>
      <!--最新帖子：{{item.content}}-->
      <template #action>
        <li>
          <Icon type="ios-chatbubbles-outline" /> 举报人 <b>{{ item.createUserName }}</b>
        </li>
        <li>
          <Icon type="ios-thumbs-up-outline" /> 提交日期 <b>{{ item.createTime }}</b>
        </li>

        <li>
          <Icon type="ios-thumbs-up-outline" /> 受理状态 <b>{{ item.statusTxt }}</b>
        </li>
      </template>
    </ListItem>
    
  </List>
  <div id="pager"><Page :total="num" @on-change="pageChange" show-total /></div>

</div>

</template>
<script>
import WebTop from '../../components/WebTop.vue'
import global from '../../utils/global'
import axios from 'axios'
export default {
  components: {
    WebTop
  },
  data () {
    return {
      user: null,
      page: 1,
      num: 0,
      applies: []
    }
  },
  mounted() {
    this.initUser()
    this.initMine()
  },
  methods: {
    //初始化用户信息
    initUser() {
      let userStr = localStorage.getItem("user")
      if(userStr!=null) {
        this.user = JSON.parse(userStr)
      } else {
        this.$router.push({path: '/'})
      }
    },

    initMine () {
      let vm = this
      //let id = this.$route.query.id
      axios({
        method: 'post',
        url: global.restUrl + '/api/web/complaint/v1.0/apply/mine',
        headers: {
          token: this.user.token
        },
        data: {
          userId: vm.user.userId,
          page: vm.page
        }
      }).then(function (response) {
        console.log(response)
        let success = response.data.success
        if(success) {
          vm.applies = response.data.data.list
        }
      });
    },
  }
}
</script>
